"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataRowDD = exports.DataRowDT = exports.DataRow = exports.DataRows = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var AccountSection = function AccountSection(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, children);
}; // Styling
var Wrapper = styled_components_1.default.section.withConfig({
    displayName: "AccountSection__Wrapper",
    componentId: "sc-1pvglfe-0"
})(["width:100%;margin-bottom:40px;&:last-of-type{margin-bottom:0;}", "{margin-bottom:48px;}", "{margin-bottom:56px;}", "{margin-bottom:64px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Additional Shared Styling
// Data Row
exports.DataRows = styled_components_1.default.dl.withConfig({
    displayName: "AccountSection__DataRows",
    componentId: "sc-1pvglfe-1"
})(["", ""], _theme_1.type.label);
exports.DataRow = styled_components_1.default.div.withConfig({
    displayName: "AccountSection__DataRow",
    componentId: "sc-1pvglfe-2"
})(["display:flex;justify-content:space-between;"]);
exports.DataRowDT = styled_components_1.default.dt.withConfig({
    displayName: "AccountSection__DataRowDT",
    componentId: "sc-1pvglfe-3"
})(["position:relative;display:block;padding:4px 16px 4px 0;width:fit-content;overflow:hidden;color:", ";", "{padding-top:8px;padding-bottom:8px;}"], _theme_1.palette.ink, _utils_1.mediaQuery('laptop'));
exports.DataRowDD = styled_components_1.default.dd.withConfig({
    displayName: "AccountSection__DataRowDD",
    componentId: "sc-1pvglfe-4"
})(["position:relative;display:block;padding:4px 0;width:fit-content;overflow:hidden;color:", ";cursor:default;&::after{position:absolute;bottom:4px;left:0;background-color:", ";width:100%;height:1px;content:'';pointer-events:none;transform:translate3d(-100%,0,0);transition:opacity 0.25s ease-in-out,transform 0.4s ease-in-out;}", "{padding:8px 0;}"], _theme_1.palette.ink, _theme_1.palette.brown, _utils_1.mediaQuery('laptop')); // Typing
exports.default = AccountSection;
